import { render } from 'react-dom';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';
import ThemeProvider from 'connect-dot-com-ui-components/theme/ThemeProvider';

// I18n Configuration
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';

// Import extra I18n data
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Configure the router
import { Router } from 'react-router-dom';
import { getRootUrl } from './utils/urls';
import { Routes } from './components/Routes';

// Tracking
import { trackInteraction, trackPageview } from './utils/usageTracker';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
export class App {
  // Kicks off the app. This is intentionally not in the constructor.
  start() {
    const I18nProvider = createPublicI18nProvider();
    const langAvailable = initAppTranslations([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    langAvailable.then(() => {
      setDocumentTitle('app.htmlTitle');
      this.startRouter();
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  startRouter() {
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    render( /*#__PURE__*/_jsx(UIApplication, {
      name: "connect-dot-com-public-ui",
      children: /*#__PURE__*/_jsx(ThemeProvider, {
        children: /*#__PURE__*/_jsx(TrackerContext.Provider, {
          value: {
            trackPageview,
            trackInteraction
          },
          children: /*#__PURE__*/_jsx(RhumbProvider, {
            history: historyAdapter(history),
            config: rhumbConfig,
            children: /*#__PURE__*/_jsx(Router, {
              history: history,
              children: /*#__PURE__*/_jsx(Routes, {})
            })
          })
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }
}